import React from "react";
import styled, { keyframes } from "styled-components";
import { EYE_VIEWBOX, EYE_VIEWBOX_DRIP, DRIP_D, BODY_D, PUPIL_D, IRIS_D } from "./eyePaths";

// CENTER EYE : the eye vector lifted from EyeTunnel_rect--has_eye.svg
// (the "Eye" / "Eye_Filled" groups) as a standalone component, so it can
// sit in the middle of the fluid background like the original tunnel's eye.
// Fills cycle through the neon triad like the source SVG's animations.

const cycleBody = keyframes`
  0%  { fill: #13FFED; }
  33% { fill: #FF01E9; }
  45% { fill: #FF01E9; }
  66% { fill: #950AFF; }
  82% { fill: #950AFF; }
  100%{ fill: #13FFED; }
`;

const cyclePupil = keyframes`
  0%  { fill: #FF01E9; }
  33% { fill: #950AFF; }
  45% { fill: #950AFF; }
  66% { fill: #13FFED; }
  82% { fill: #13FFED; }
  100%{ fill: #FF01E9; }
`;

const cycleIris = keyframes`
  0%  { fill: #950AFF; }
  33% { fill: #13FFED; }
  45% { fill: #13FFED; }
  66% { fill: #FF01E9; }
  82% { fill: #FF01E9; }
  100%{ fill: #950AFF; }
`;

const EyeSvg = styled.svg`
  display: block;

  .eye_body {
    fill: #13FFED;
    stroke: #333333;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    animation: ${cycleBody} 7s ease-in-out infinite;
    will-change: fill;
  }

  .eye_pupil {
    fill: #FF01E9;
    stroke: #333333;
    stroke-width: 2;
    stroke-miterlimit: 10;
    animation: ${cyclePupil} 7s ease-in-out infinite;
    will-change: fill;
  }

  .eye_iris {
    fill: #950AFF;
    stroke: #333333;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
    animation: ${cycleIris} 28s ease-in-out infinite;
    will-change: fill;
  }

  .drip {
    fill: #13FFED;
    stroke: #333333;
    stroke-width: 2.5;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-miterlimit: 10;
  }

  // STATIC MODE : fixed per-instance ring colors instead of the palette
  // cycle -- used where the eye sits next to other themed-color UI it
  // needs to visually match rather than animate independently of
  &.no-animate {
    .eye_body,
    .eye_pupil,
    .eye_iris {
      animation: none;
    }
  }
`;

const CenterEye = ({
  width = 180,
  showDrip = false,
  style,
  className,
  animated = true,
  bodyColor,
  pupilColor,
  irisColor,
}) => (
  <EyeSvg
    xmlns="http://www.w3.org/2000/svg"
    viewBox={showDrip ? EYE_VIEWBOX_DRIP : EYE_VIEWBOX}
    width={width}
    style={style}
    className={`${className || ''} ${animated ? '' : 'no-animate'}`.trim()}
    aria-hidden="true"
    focusable="false"
  >
    {showDrip &&
      <path className="drip" d={DRIP_D} />
    }
    <path className="eye_body" d={BODY_D} style={bodyColor ? { fill: bodyColor } : undefined} />
    <path className="eye_pupil" d={PUPIL_D} style={pupilColor ? { fill: pupilColor } : undefined} />
    <path className="eye_iris" d={IRIS_D} style={irisColor ? { fill: irisColor } : undefined} />
  </EyeSvg>
);

export default CenterEye;
